/*
* @描述: 报价单分享详情
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025-01-14 17:39:01
*/
<template>
    <div class="quotation_share_detail_page">
        <div v-if="quotationShareShow" v-loading="loading" class="quotation_share_board">
            <div id="watermark"
                 :style="{ backgroundImage: `url(${watermarkUrl})` }"
                 class="quotation_template_wrap">
                <TemplateComponent v-if="dataLoaded"
                                   ref="templateComponent"
                                   :fields_list="quotationFieldsList"
                                   :project_quotation_tmpl_form="project_quotation_tmpl_form"
                                   :quotation_detail="projectQuotationDetail"
                                   :templateType="'detail'"/>
            </div>
            <div>
                <div class="feedback_title">评论</div>
                <div class="feedback_wrap">
                    <ul class="feedback_status_list">
                        <li :class="{'active':feedbackForm.status===2}" class="feedback_status_item"
                            @click="feedbackForm.status=2">存在异议
                        </li>
                        <li :class="{'active':feedbackForm.status===1}" class="feedback_status_item"
                            @click="feedbackForm.status=1">没问题
                        </li>
                    </ul>
                    <el-input v-model="feedbackForm.content"
                              :rows="3"
                              maxlength="200"
                              placeholder="可以在此录入您的问题或反馈，报价人员即可收到并与您进一步沟通"
                              type="textarea"></el-input>
                </div>
                <div class="ta_c">
                    <el-button :disabled="feedbackForm.content===''"
                               class="submit_btn"
                               size="small"
                               type="primary"
                               @click="handleClickSubmit">提交
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {projectQuotationFeedback, projectQuotationShareDetail} from "@/api";
import watermark from "watermark-dom";
import TemplateComponent from "@/views/pc/Business/component/template_component";

export default {
    name: "QuotationShareDetails",
    data() {
        return {
            loading: false,
            watermarkUrl: null,
            userName: "",
            phone: "",
            projectQuotationDetail: {},
            quotationFieldsList: [],
            project_quotation_tmpl_form: '',
            dataLoaded: false,
            feedbackForm: {
                key: '',
                project_quotation_id: '',
                company_id: '',
                content: '',
                status: 1
            },
            quotationShareShow: false
        }
    },
    components: {TemplateComponent},
    created() {
        if (this.$route.query) {
            const data = this.$route.query;
            this.feedbackForm.key = data.key;
            this.userName = data.name;
            this.phone = data.phone;
            this.getQuotationDetail()
        }
    },
    computed: {},
    mounted() {
        this.createWatermark();
    },
    methods: {
        //获取报价单详情
        getQuotationDetail() {
            this.loading = true
            projectQuotationShareDetail(this.feedbackForm.key).then(res => {
                if (res.code === 200) {
                    this.loading = false
                    this.project_quotation_tmpl_form = res.data.project_quotation_tmpl_form
                    this.quotationFieldsList = res.data.custom_fields
                    this.feedbackForm.project_quotation_id = res.data.project_quotation_id
                    this.feedbackForm.company_id = res.data.company_id
                    this.projectQuotationDetail = res.data
                    this.quotationShareShow = true
                    this.dataLoaded = true
                } else if (res.code === 9202) {
                    this.loading = false
                    this.quotationShareShow = false
                    this.$confirm('该报价单已失效，请联系销售人员', '提示', {
                        type: 'warning',
                        showCancelButton: false,
                        confirmButtonText: '确定',
                    }).then(() => {

                    }).catch(() => {
                    })
                } else {
                    this.loading = false
                    this.quotationShareShow = false
                }
            })
        },

        createWatermark() {
            const options = {
                watermark_parent_node: "watermark",
                watermark_txt: this.userName + this.phone,
                watermark_color: "gray",
                watermark_fontsize: "14px",
                watermark_rows: 6, //水印行数
                watermark_cols: 6, // 水印列数
                watermark_x: 20, //水印起始位置x轴坐标
                watermark_y: 0, //水印起始位置Y轴坐标
                watermark_x_space: -10,
                watermark_angle: 45,
            };
            watermark.load(options);
        },

        handleClickSubmit() {
            projectQuotationFeedback(this.feedbackForm).then(res => {
                if (res.code === 200) {
                    this.$message.success('提交成功')
                    this.feedbackForm.content = ''
                } else {
                    this.$message.error(res.message)
                }
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.quotation_share_detail_page {
    width: 100%;
    height: 100vh;
    background: url('https://download.hecoos.com/enlightv/2024-04/eSKDGcX5iprHf4Ekm2Eb.jpg') no-repeat;
    background-size: 100% 100%;
    padding: 60px 0;

    .quotation_share_board {
        width: 1000px;
        height: 100%;
        overflow-y: auto;
        margin: 0 auto;
        background-color: #FFFFFF;
        border-radius: 8px;
        padding: 10px;

        .quotation_template_wrap {
            margin-bottom: 24px;
            max-height: calc(100% - 234px);
            overflow-y: auto;
        }
    }

    .feedback_title {
        font-size: 14px;
        line-height: 22px;
        color: #333333;
        margin-bottom: 4px;
    }

    .feedback_wrap {
        width: 100%;
        height: 128px;
        border-radius: 6px;
        border: 1px solid #D9D9D9;
        padding: 12px;
        margin-bottom: 24px;

        .feedback_status_list {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 8px;

            .feedback_status_item {
                border-radius: 4px;
                background: #F7F7F7;
                height: 22px;
                line-height: 22px;
                padding: 0 8px;
                cursor: pointer;
                color: #666666;

                &:hover {
                    background: #EDEDED;
                }

                &.active {
                    background-color: rgba(41, 144, 255, 0.1);
                    color: #29B0FF;
                }
            }
        }

        ::v-deep .el-textarea__inner {
            padding: 0;
            border: none;
            color: #666666;
            font-size: 14px;
            line-height: 22px;
            resize: unset;
        }
    }

    .submit_btn {
        padding: 9px 30px;
    }
}
</style>
